import { action, observable, makeObservable } from 'mobx';

export default class AnalysisStore {
    activeTargetGroupId: string | null = null;
    activeBoxId: string | null = '';

    constructor() {
        makeObservable(this, {
            activeTargetGroupId: observable,
            activeBoxId: observable,
            setActiveTargetGroup: action,
            setActiveBox: action
        });
    }

    setActiveTargetGroup(targetGroupId: string | null): void {
        this.activeTargetGroupId = targetGroupId;
    }

    setActiveBox(boxId: string | null): void {
        this.activeBoxId = boxId;
    }
}
